import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import InvoiceTotal from 'features/Invoice/InvoiceTotal'
import { directfulServiceTypes } from 'main/directfulServices'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { formatPrice } from '../../../utils/common'
import styles from '../BillingManagement.module.scss'

const BottomBar = ({
  completingReview,
  handleReviewComplete,
  skipMonth,
  isSkippingMonth
}) => {
  const totalAmountDue = useSelector(s => s.invoices.totalAmountDue)
  const totalFixedServices = useSelector(s => s.invoices.totalFixedServices)
  const totalTax = useSelector(s => s.invoices.totalTax)
  const status = useSelector(s => s.invoices?.billableInvoiceDetails?.status)
  const billableSubsidiaryServices = useSelector(
    s => s.invoices.billableSubsidiaryServices
  )

  const taxRate = useSelector(s => s.invoices.billingTaxRate)
  const invoiceDetails = useSelector(s => s.invoices.billableInvoiceDetails)

  const COMMISSION = 0.05
  const conversionsForInvoiceReview = useSelector(s => s.invoices.billableBookings)

  const estimatedCommission = conversionsForInvoiceReview.reduce(
    (prev, curr) =>
      prev + (curr.isInvoicingRejected ? 0 : curr.convertedTotal * COMMISSION),
    0
  )

  const [isBreakdownVisible, setIsBreakdownVisible] = useState(false)

  return (
    <>
      {isBreakdownVisible && (
        <ConfirmationDialog
          title="Price breakdown"
          onClose={() => setIsBreakdownVisible(false)}
          theme="blacklist"
        >
          <div style={{ paddingTop: 20 }}>
            <InvoiceTotal invoiceDetails={invoiceDetails} taxRate={taxRate} />
          </div>
        </ConfirmationDialog>
      )}
      <div className={styles.bottomBlocker}></div>
      <div className={styles.bottomBar}>
        <div className={styles.priceHolder}>
          <div className={styles.totalPrice}>
            <span>Total</span>
            <span>{formatPrice(totalAmountDue)}</span>
            <button
              className={styles.breakdownLink}
              onClick={() => setIsBreakdownVisible(true)}
            >
              Show breakdown
            </button>
          </div>
          <div className={styles.taxPrice}>
            {totalFixedServices > 0 && (
              <>
                <span>Fixed services</span>
                <span>{formatPrice(totalFixedServices)}</span>
                <span>&middot;</span>
              </>
            )}
            <span>Tax</span>
            <span>{formatPrice(totalTax)}</span>
            {billableSubsidiaryServices?.find(
              s => s.plan === directfulServiceTypes.AutoInviteLite
            ) && (
              <>
                <span>&middot;</span>
                <span>Estimated commission</span>
                <span>{formatPrice(estimatedCommission)}</span>
              </>
            )}
          </div>
        </div>
        <div className={styles.submitHolder}>
          {status === 'ReviewPending' && (
            <button
              disabled={completingReview}
              className={styles.cta}
              onClick={handleReviewComplete}
            >
              {completingReview ? 'Completing review...' : 'Complete review'}
            </button>
          )}
          {(status === 'ReviewPending' || status === 'ReviewCompleted') && (
            <button
              className={styles.secondaryCta}
              onClick={skipMonth}
              disabled={isSkippingMonth}
            >
              Skip month
            </button>
          )}
          <Link to="/billing">
            <button className={styles.secondaryCta}>Close</button>
          </Link>
        </div>
      </div>
    </>
  )
}

export default BottomBar
